import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SearchBarContext from '../context';
import { usePutRemoveRecentSearches } from '../../../../../services/search/recent-service';

const Recent = styled.span`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: ${props => props.width}px;
  padding-right: ${props => (props.theme.isMobile ? 2 : 5)}px;

  & > strong {
    float: right;
    position: relative;
    top: 4px;
    margin-left: ${props => (props.theme.isMobile ? 2 : 5)}px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    width: ${props => (props.theme.isMobile ? 54 : 64)}px;
    height: 20px;
    background-color: ${props => props.theme.secondaryColor};
    font-size: 11px;
    line-height: 20px;
    border-radius: 2px;
    color: white;
    text-transform: uppercase;
  }
`;

// search bar width, minus 2 horizontal paddings, minus the width of `Company`
const getWidth = w => w - 20 * 2 - 28;

// eslint-disable-next-line camelcase
export default function RecentEntry({ id, decorated_query }) {
  const { state: { rsearch, width }, dispatch } = React.useContext(SearchBarContext);
  const [, remove] = usePutRemoveRecentSearches();

  const removeEntry = React.useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    remove(id).then(() => {
      dispatch({
        type: 'setRecentSearchResult',
        payload: _.filter(rsearch, d => d.id !== id),
      });
      dispatch({ type: 'setValue', payload: '' });
    });
  }, [remove, id, dispatch, rsearch]);

  return (
    <React.Fragment>
      <Recent
        dangerouslySetInnerHTML={{ __html: decorated_query }}
        width={getWidth(width)}
      />
      <a href="#" onClick={removeEntry}>remove</a>
    </React.Fragment>
  );
}

RecentEntry.propTypes = {
  id: PropTypes.number.isRequired,
  decorated_query: PropTypes.string.isRequired,
};
